import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '@/lib/utils';
// Generate a consistent color based on email hash
function getAvatarColor(email) {
    const colors = [
        'bg-red-500',
        'bg-orange-500',
        'bg-amber-500',
        'bg-yellow-500',
        'bg-lime-500',
        'bg-green-500',
        'bg-emerald-500',
        'bg-teal-500',
        'bg-cyan-500',
        'bg-sky-500',
        'bg-blue-500',
        'bg-indigo-500',
        'bg-violet-500',
        'bg-purple-500',
        'bg-fuchsia-500',
        'bg-pink-500',
    ];
    let hash = 0;
    for (let i = 0; i < email.length; i++) {
        hash = email.charCodeAt(i) + ((hash << 5) - hash);
    }
    return colors[Math.abs(hash) % colors.length];
}
function getInitials(firstName, lastName, email) {
    if (firstName && lastName) {
        return `${firstName[0]}${lastName[0]}`.toUpperCase();
    }
    if (firstName) {
        return firstName.slice(0, 2).toUpperCase();
    }
    if (email) {
        return email.slice(0, 2).toUpperCase();
    }
    return '??';
}
const sizeClasses = {
    sm: 'h-8 w-8 text-xs',
    md: 'h-10 w-10 text-sm',
    lg: 'h-14 w-14 text-lg',
};
export function UserAvatar({ firstName, lastName, email, avatarUrl, size = 'md', className, }) {
    const initials = getInitials(firstName, lastName, email);
    const bgColor = getAvatarColor(email);
    if (avatarUrl) {
        return (_jsx("img", { src: avatarUrl, alt: `${firstName || email}'s avatar`, className: cn('rounded-full object-cover', sizeClasses[size], className) }));
    }
    return (_jsx("div", { className: cn('flex items-center justify-center rounded-full font-semibold text-white', bgColor, sizeClasses[size], className), children: initials }));
}
